import {Col, Row} from "reactstrap";
import * as constants from "../../const/constants";
import React, {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {searchCourse} from "../../services/courses";
// import moment from "moment";
import moment from 'moment-timezone';
import swal from "sweetalert";
import {lang, language} from "../../const/language";
import {useDispatch, useSelector} from "react-redux";


export default function CourseSlideV3({course, onRegister}) {

    const [courseForUser, setCourseForUser] = useState({
        courseId: 1,
        name: "",
        startDate: "",
        endDate: "",
        status: "",
        noOfSemesters: 0,
        noOfInstallments: 0,
        description: "",
        imageUrl: "",
        videoUrl: null,
        videoSize: 0,
        totalFee: 1000.00,
        created: "",
        updated: "",
        coursesDayTimes: [],
        courseTeachers: [],
        courseInstallmentList: [],
        nextDayOfCourseSession: "",
        courseEnrollType: null,
        coursePaymentDetails: null,
        quizAvailable: false,
        pending: false
    })

    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    const userType = useSelector(state => state.auth.userType);

    const {
        buttonStatus,
        nextDayOfClass,
        teacherClassResponse,
        dayTimes,
        imageUrl,
        name,
        fee,
        totalFee,
        courseId,
        courseInstallmentList
    } = course;

    useEffect(() => {
        (async function findCourseById() {
            if (course && course.courseId) {
                const response = await searchCourse(Number.parseInt(courseId));
                if (response && response.success && response.body) {
                    setCourseForUser(response.body)
                }
            }
        })()
    }, []);

    let installmentCount = 1;

    if (courseInstallmentList) {
        installmentCount = courseInstallmentList.length;
    }

    // find if registration closed
    let isRegistrationClosed = false;

    if (course.startDate) {
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        const localTime = moment().tz(userTimeZone);

        const registrationCloseTime = moment.tz(`${course.startDate} 23:59:59`, userTimeZone).add(21, 'days');

        // Check if registration is closed
        isRegistrationClosed = localTime.isAfter(registrationCloseTime);
    }


    // if (courseForUser.startDate) {
    //     const localTime = moment().format('YYYY-MM-DD HH:mm:ss'); // Local time in user's time zone
    //     const courseStartTime = moment(`${courseForUser.startDate} 23:59:59`);
    //     isRegistrationClosed = moment().isAfter(moment(courseForUser.startDate));
    // }

    // find teacher
    let teacher = {
        teacherName: "",
        qualification: "",
        description: "",
        imageUrl: "",
        bankNumber: "",
        bankName: "",
        branchName: "",
        accHolderName: ""
    };

    if (courseForUser.courseTeachers.length > 0) {
        teacher.teacherName = courseForUser.courseTeachers[0].name;
        teacher.qualification = courseForUser.courseTeachers[0].qualification;
        teacher.description = courseForUser.courseTeachers[0].description;
        teacher.imageUrl = courseForUser.courseTeachers[0].imageUrl;
        teacher.bankNumber = courseForUser.courseTeachers[0].bankNumber;
        teacher.bankName = courseForUser.courseTeachers[0].bankName;
        teacher.branchName = courseForUser.courseTeachers[0].branchName;
        teacher.accHolderName = courseForUser.courseTeachers[0].accHolderName;
    }


    // check course payment status

    let isFullCourseFeePaid = false;
    let isPartiallyPaid = false;

    if (courseForUser && courseForUser.coursePaymentDetails && courseForUser.coursePaymentDetails.length > 0) {

        // check course fee is fully paid with one installment
        if (courseForUser.courseEnrollType && courseForUser.courseEnrollType === "FULL") {
            const payment = courseForUser.coursePaymentDetails[0];
            const {buttonStatus} = payment;
            if (buttonStatus === 'BOUGHT') {
                isFullCourseFeePaid = true;
            }
        }

        // check course fee is fully paid or partially paid
        if (courseForUser.courseEnrollType && courseForUser.courseEnrollType === "INSTALLMENTS") {
            const boughtStatuses = courseForUser.coursePaymentDetails.filter(paymentDetail => {
                const {buttonStatus} = paymentDetail;
                return buttonStatus === "BOUGHT";
            })

            if (boughtStatuses.length === courseForUser.courseInstallmentList.length) {
                isFullCourseFeePaid = true;

            } else if (boughtStatuses.length > 0 && boughtStatuses.length < courseForUser.courseInstallmentList.length) {
                isFullCourseFeePaid = false;
                isPartiallyPaid = true;
            }
        }

    }

    let paymentBtnText = "REGISTER FOR THIS COURSE";

    if (courseForUser.pending) {
        paymentBtnText = "PAYMENT APPROVAL PENDING";

    } else if (isPartiallyPaid) {
        paymentBtnText = "MAKE REMAINING PAYMENTS"

    } else if (isFullCourseFeePaid) {
        paymentBtnText = "ALREADY REGISTERED";
    }

    let isRegisterBtnDisabled = isRegistrationClosed && paymentBtnText === "REGISTER FOR THIS COURSE";

    const handleRegisterOnClick = (courseId, course, teacher) => {

        if (!userType || userType !== 1) {
            swal({
                title: constants.GUEST_STUDENT_FOR_PURCHASE,
                icon: null,
                closeOnClickOutside: false,
                buttons: {
                    cancel: language[lang].NotNowText,
                    dangerMode: {text: language[lang].OkayText, value: "action", className: "okay-btn"}
                },
            }).then((value) => {
                switch (value) {
                    case "action":
                        // location.href = (`${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`)
                        history.push(`${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`);
                        break;
                    default:
                        break;
                }
            });
        }

        if(userType === 1){
            onRegister(courseId, course, teacher);
        }
    }

    return (
        <div>

            <div className={"slideshow-wrapper shadow"}>

                <Row style={{width: "100%", cursor: 'pointer'}} className={"no-gutters"}>
                    <Col>
                        <img
                            onClick={() => {
                                history.push({
                                    pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_COURSE_ROUTE}`,
                                    state: {id: courseId}
                                })
                            }}
                            style={{
                                objectFit: 'cover',
                                aspectRatio: "3/1.6",
                                borderRadius: 8,
                                cursor: 'pointer'
                            }}
                            src={imageUrl} alt={"cover-img"}
                            width={"100%"}/>
                    </Col>
                </Row>

                <div style={{padding: 20, borderRadius: 8}} className={"shadow"}>

                    <Row>
                        <Col>
                            <div style={{
                                color: 'black',
                                paddingBottom: 10,
                                fontSize: 24,
                                fontWeight: 'bold'
                            }}>
                                {name}
                            </div>
                        </Col>
                    </Row>

                    <Row className={"no-gutters"} style={{paddingTop: 20}}>
                        <Col style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 10
                        }}>
                            <button
                                onClick={() => {
                                    history.push({
                                        pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_COURSE_ROUTE}`,
                                        state: {id: courseId}
                                    })
                                }}
                                style={{
                                    width: '100%',
                                    borderRadius: 8,
                                    color: 'white',
                                    padding: 20,
                                    backgroundColor: "maroon"
                                }}>FIND
                                OUT MORE
                            </button>
                            {
                                !isRegistrationClosed &&
                                <button
                                    onClick={() => {
                                        if (courseForUser.pending) {
                                            history.push({
                                                pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_COURSE_ROUTE}`,
                                                state: {id: courseId}
                                            })
                                        } else if (isFullCourseFeePaid) {
                                            history.push({
                                                pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_COURSE_ROUTE}`,
                                                state: {id: courseId}
                                            })
                                        } else {
                                            handleRegisterOnClick(courseId, course, teacher);
                                        }
                                    }}
                                    style={{
                                        borderRadius: 8,
                                        width: '100%',
                                        color: 'white',
                                        backgroundColor: courseForUser.pending ? "black" : '#344054',
                                        padding: 20
                                    }}>
                                    {paymentBtnText}
                                </button>
                            }
                        </Col>
                    </Row>

                </div>

            </div>
        </div>
    );
}
